import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(modalOpenSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(modalOpenSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseWithAnswerSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseWithAnswerSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(modalsSaga);

import { all, delay, fork, put, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { INIT_CLOSE_MODAL, INIT_MODAL_CLOSING_WITH_ANSWER, MODAL_INIT } from './modals.action-types';
import { actions } from './modals.actions';

function modalOpenSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalOpenSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.setModal({
            modalId: action.payload.modalId,
            isOpen: action.payload.isOpen,
            data: action.payload.data
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function modalOpenSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalOpenSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(MODAL_INIT, modalOpenSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function modalCloseSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalCloseSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.hideModal({
            modalId: action.payload.modalId
          }));

        case 2:
          _context3.next = 4;
          return delay(250);

        case 4:
          _context3.next = 6;
          return put(actions.modalClose({
            modalId: action.payload.modalId
          }));

        case 6:
          _context3.next = 8;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(action.payload.modalId, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              modalId: action.payload.modalId
            }
          });

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function modalCloseSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalCloseSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_CLOSE_MODAL, modalCloseSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function modalCloseWithAnswerSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalCloseWithAnswerSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.hideModal({
            modalId: action.payload.modalId
          }));

        case 2:
          _context5.next = 4;
          return delay(250);

        case 4:
          _context5.next = 6;
          return put(actions.closeWithAnswer({
            modalId: action.payload.modalId,
            accepted: action.payload.accepted,
            rejected: action.payload.rejected,
            closeData: action.payload.closeData
          }));

        case 6:
          if (!action.payload.accepted) {
            _context5.next = 11;
            break;
          }

          _context5.next = 9;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(action.payload.modalId, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              modalId: action.payload.modalId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected,
              closeData: action.payload.closeData
            }
          });

        case 9:
          _context5.next = 13;
          break;

        case 11:
          _context5.next = 13;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(action.payload.modalId, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            error: {
              modalId: action.payload.modalId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected,
              closeData: action.payload.closeData
            }
          });

        case 13:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function modalCloseWithAnswerSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalCloseWithAnswerSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_MODAL_CLOSING_WITH_ANSWER, modalCloseWithAnswerSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

export default function modalsSaga() {
  return _regeneratorRuntime.wrap(function modalsSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(modalOpenSagaWatcher), fork(modalCloseSagaWatcher), fork(modalCloseWithAnswerSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}